import React, { useState } from "react";
import { X, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const AnnouncementBar = () => {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="announcement-bar">
      <Link to="/pages/waitlist-registration" className="announcement-link">
        <Clock size={14} strokeWidth={1.5} />
        <span>Register Your Interest</span>
      </Link>
      <button className="announcement-close" onClick={() => setOpen(false)} aria-label="Close">
        <X size={16} strokeWidth={1.5} />
      </button>
    </div>
  );
};

export default AnnouncementBar;
